import { Component, OnInit } from '@angular/core';
import { Flight, BookedTrip } from '@ibe/models';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import { SidebarService } from '@ibe/services/ui';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-original-flights',
	templateUrl: './original-flights.component.html',
	styleUrls: ['./original-flights.component.scss']
})
export class OriginalFlightsComponent implements OnInit {

	oldflight: Flight;
	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booked_trip: BookedTrip;

	constructor(
		private store: Store<any>,
		private sidebarService: SidebarService,

	) {
		this.oldflight = Object.assign(new Flight(null, null, null), {
			'departure': {
				'airport': {
					'name': 'LISBOA',
					'code': 'LIS',
					'label': 'LISBOA',
					'direct': null,
					'location': {
						'city': 'Lisbon',
						'cityName': 'LIS',
						'alias': 'Lisbon, Portugal(SunD\'or,×œ×™×¡×‘×•×Ÿ, ×¤×•×¨×˜×•×’×œ(×¡××Ÿ ×“×•×¨, ×œ×™×¡×‘×•×Ÿ, ×¤×•×¨×˜×•×’×œ, Portugal, LIS, ×š×Ÿ×“× ××ž, ×¤××¨××•×¢×©×š, khxcui, puryudk',
						'country': 'Portugal',
						'countryName': 'PT'
					}
				},
				time: new Date('2020-11-21T10:30:00.000Z')
			},
			'arrival': {
				'airport': {
					'name': 'El Prat',
					'code': 'BCN',
					'label': 'El Prat',
					'direct': null,
					'location': {
						'city': 'Barcelona',
						'cityName': 'BCN',
						'alias': 'Barcelona, Spain, ×‘×¨×¦×œ×•× ×”, ×¡×¤×¨×“, BCN, crmkubv, xprs, × ×©×¨×‘×§×š××ž×©, ×“×¤×©×Ÿ×ž',
						'country': 'Spain',
						'countryName': 'ES'
					}
				},
				time: new Date('2020-11-21T12:50:00.000Z')
			},
			'id': '1100',
			'number': 'TP 1234',
			'direct': true,
			'airline': [
				{
					'logo': 'TP',
					'name': 'TAP Air Portugal',
					'short': 'TAP',
					airplane: {
						'id': 'A319',
						'icon': '',
						'label': 'A319'
					},
					starAlliance: true
				}
			],
			'options': {
				'price': 239.64,
				'brand': 'top-executive',
				features: []
			},
			'status': 'cancelled',
			'check_in': {
				'status': 'not available',
				time: new Date('2019-11-19T22:30:00.000Z')
			}
		});

		this.bookedTrip$.subscribe(value => {
			if (value) {
				this.booked_trip = value;
			}
		});
	}

	ngOnInit() {
	}

	TAP_handleClose() {
		this.sidebarService.close();
	}

	TAP_printFlightDate(flight): string {
		const date = new Date(flight.departure.time);
		return date.toLocaleDateString(environment.locale, {
			weekday: 'long',
			month: 'long',
			day: 'numeric'
		});
	}

	TAP_handleTicketConditionsClick(flight) {

		this.sidebarService.openSidebar([
			'ticket-conditions',
			{ flight: flight.id }
		]);
	}
}
